var _path, _path2, _path3, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgPodcastAddict = function SvgPodcastAddict(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M49.708 64H14.292C6.427 64 0 57.554 0 49.664V14.336C0 6.446 6.427 0 14.292 0h35.416C57.56 0 64 6.446 64 14.336v35.328C64 57.554 57.56 64 49.708 64Z",
    fill: "#F4842D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.997 64h14.71C57.56 64 64 57.554 64 49.664V35.528L46.603 18.124l-17.007-4.597-15.133 18.57 3.396 14.771L34.996 64Z",
    fill: "url(#PodcastAddict_svg__a)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M52.444 31.553C52.192 20.402 43.08 11.43 31.86 11.43c-11.374 0-20.583 9.223-20.583 20.584 0 7.867 4.416 14.714 10.913 18.18V31.916c0-4.765 3.424-8.733 7.938-9.6v3.424a6.435 6.435 0 0 0-4.612 6.176V32c.042 3.521 2.92 6.358 6.442 6.358 2.92 0 5.38-1.942 6.177-4.597h3.423c-.866 4.513-4.835 7.923-9.6 7.923a9.728 9.728 0 0 1-6.442-2.432v12.353a20.742 20.742 0 0 0 6.358 1.006c4.276 0 8.245-1.3 11.543-3.535v3.535h9.04l-.013-21.058Zm-20.5 4.122a3.751 3.751 0 0 1-3.759-3.759 3.751 3.751 0 0 1 3.76-3.759 3.751 3.751 0 0 1 3.758 3.76 3.751 3.751 0 0 1-3.759 3.758Zm9.782-3.73H38.4v-.029a6.435 6.435 0 0 0-6.442-6.442h-.014v-3.326h.014c5.394 0 9.768 4.374 9.768 9.768v.028Zm5.73 0h-3.299v-.029c0-6.735-5.463-12.199-12.199-12.199h-.014v-3.298h.014c8.566 0 15.497 6.945 15.497 15.497v.028Z",
    fill: "#fff"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "PodcastAddict_svg__a",
    x1: 23.269,
    y1: 23.451,
    x2: 75.836,
    y2: 76.174,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#E85D27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.687,
    stopColor: "#F0772B"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgPodcastAddict);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "5b1e6076e9843187ac1b0c86de4b7ae9.svg";